import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ezc1gekjy: FaireProductEntity = {
  token: "p_7ezc1gekjy",
  type: "product",
  name: "3.4 oz Sea Mist",
  brandName: "Scent Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/87f74ac9a565fd3a527a29016b8b466ad6ae332645c3b8f9cf7e2cde123b03f4.jpeg",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7a86262cbdcb543478aa8f293cffd4eb0f696aa590e0b23997b3baf136c79a5b.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
